import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Plus } from "lucide-react";
import { toast } from "sonner";

export default function PartnerCompaniesPage() {
    const { api } = useAuth();
    const [rows, setRows] = useState([]);
    const [entering, setEntering] = useState(null);

    useEffect(() => {
        api.get("/v2/partner/workspaces").then(r => setRows(r.data.workspaces || [])).catch(() => {});
    }, [api]);

    const enterWorkspace = async (ws) => {
        setEntering(ws.id);
        try {
            const r = await api.post(`/v2/partner/workspaces/${ws.id}/enter`);
            localStorage.setItem("partner_origin_token", localStorage.getItem("token"));
            localStorage.setItem("partner_acting_workspace_name", ws.name);
            localStorage.setItem("token", r.data.token);
            toast.success(`Entered ${ws.name}`);
            window.location.href = "/enterprise";
        } catch (e) {
            toast.error(e.response?.data?.detail || "Could not enter workspace");
            setEntering(null);
        }
    };

    return (
        <div data-testid="partner-companies-page">
            <div className="mb-8 flex items-baseline justify-between">
                <div>
                    <h1 className="text-3xl font-display font-bold text-white">Companies</h1>
                    <p className="text-sm text-gray-500 mt-1">Workspaces in your portfolio.</p>
                </div>
                <Link to="/partner/companies/new"
                    className="bg-white text-black px-4 py-2 text-sm font-semibold hover:bg-gray-200 inline-flex items-center gap-2"
                    data-testid="provision-new-company-btn">
                    <Plus className="w-4 h-4" /> Provision New Company
                </Link>
            </div>

            <div className="bg-card border border-border/40">
                <div className="grid grid-cols-[2fr_1fr_1fr_120px_120px_140px] px-5 py-3 border-b border-border/40 text-xs text-gray-600 font-body uppercase tracking-wider">
                    <span>Company</span><span>Industry</span><span>Country</span><span>Candidates</span><span>Users</span><span>Provisioned</span>
                </div>
                {rows.map(w => (
                    <div key={w.id} className="grid grid-cols-[2fr_1fr_1fr_120px_120px_140px] px-5 py-3 border-b border-border/20 items-center hover:bg-white/[0.01]"
                        data-testid={`company-row-${w.id}`}>
                        <button onClick={() => enterWorkspace(w)}
                            disabled={entering === w.id}
                            className="text-sm text-white hover:underline text-left disabled:opacity-50">
                            {w.name} {entering === w.id && <span className="text-gray-500 font-mono text-xs">· entering…</span>}
                        </button>
                        <span className="text-xs text-gray-400 font-mono">{w.primary_industry || "—"}</span>
                        <span className="text-xs text-gray-400 font-mono">{w.geographic_footprint || "—"}</span>
                        <span className="text-xs text-white font-mono">{w.candidate_count}</span>
                        <span className="text-xs text-white font-mono">{w.user_count}</span>
                        <span className="text-xs text-gray-600 font-mono">{w.provisioned_at?.slice(0, 10)}</span>
                    </div>
                ))}
                {rows.length === 0 && (
                    <div className="px-5 py-10 text-xs text-gray-500 text-center">No companies yet.</div>
                )}
            </div>
        </div>
    );
}
